import { Box, Text } from "@mantine/core";
import { Link } from "react-router";
import "./MenuLink.scss";

interface MenuLinkProps {
  to: string;
  text: string;
}

function MenuLink({ to, text }: MenuLinkProps) {
  return (
    <Box component={Link} display="flex" td="none" to={to}>
      <Text
        className="MenuLinkText"
        flex={1}
        miw={0}
        span
        title={text}
        truncate
      >
        {text}
      </Text>
    </Box>
  );
}

export { MenuLink };
